module.exports = __webpack_public_path__ + "img/Powered_by_ffly4u.89849544.png";